import { render, staticRenderFns } from "./ButtonSendTokensToModel.vue?vue&type=template&id=1c135b99&scoped=true&"
import script from "./ButtonSendTokensToModel.vue?vue&type=script&lang=js&"
export * from "./ButtonSendTokensToModel.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSendTokensToModel.vue?vue&type=style&index=0&id=1c135b99&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c135b99",
  null
  
)

export default component.exports